export function ImgMenu({ size = 24 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4 18L20 18" />
      <path d="M4 12L20 12" />
      <path d="M4 6L20 6" />
    </svg>
  );
}